import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Slide5() {
  const rows = [{
    left: 'Static assets',
    right: 'Interactive journeys'
  }, {
    left: 'One-size campaigns',
    right: 'Personalized engagement'
  }, {
    left: 'Rebuilt per market',
    right: 'Instant localization'
  }, {
    left: 'No insight',
    right: 'Behavioral data'
  }];
  return <div className="slide-content" data-id="element-106">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-107">
        <h1 className="slide-headline" data-id="element-108">
          Same input. <span className="text-roche-red" data-id="element-109">Better output.</span>
        </h1>
      </motion.div>

      <div className="flex-1 flex flex-col justify-center max-w-5xl mx-auto w-full mt-8" data-id="element-110">
        {/* Headers */}
        <div className="grid grid-cols-[1fr_auto_1fr] gap-8 mb-8 px-8" data-id="element-111">
          <motion.div className="text-xl font-semibold text-text-muted uppercase tracking-wider text-right" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-112">
            Today
          </motion.div>
          <div className="w-12" data-id="element-113"></div>
          <motion.div className="text-xl font-semibold text-roche-red uppercase tracking-wider" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-114">
            Snakker
          </motion.div>
        </div>

        {/* Rows */}
        <div className="space-y-4" data-id="element-115">
          {rows.map((row, index) => <motion.div key={index} className="grid grid-cols-[1fr_auto_1fr] gap-8 items-center bg-card-bg rounded-xl p-6 border border-gray-100" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4 + index * 0.15
        }} data-id="element-116">
              <div className="text-2xl text-text-muted text-right font-medium" data-id="element-117">
                {row.left}
              </div>

              <div className="w-12 flex justify-center" data-id="element-118">
                <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              type: 'spring',
              delay: 0.6 + index * 0.15
            }} data-id="element-119">
                  <ArrowRight className="w-6 h-6 text-roche-red opacity-50" data-id="element-120" />
                </motion.div>
              </div>

              <div className="text-2xl font-bold text-text-main" data-id="element-121">
                {row.right}
              </div>
            </motion.div>)}
        </div>
      </div>

      <motion.div className="slide-punchline text-center w-full" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 1.2
    }} data-id="element-122">
        From campaigns <span className="text-text-main mx-2" data-id="element-123">→</span> to a
        system
      </motion.div>
    </div>;
}